import { onCLS } from 'web-vitals';

/**
 * This metric uses the deprecated performance.memory API and may not be reliable in the future. At
 * time of writing there are no other viable options for measuring memory. The newer
 * measureUserAgentSpecificMemory API requires a large lift where all third party resources need
 * CORS.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Performance/memory
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Performance/measureUserAgentSpecificMemory
 *
 * @param {Function} trackPerformanceMetricEvent - A tracking function created with the
 * @buzzfeed/client-event-tracking `createClientEvent` method.
 */
const memory = ((trackPerformanceMetricEvent) => {
  onCLS(function memoryMetric() {
    if (!performance.memory) {
      return;
    }

    const memoryInfo = performance.memory;
    const metric_metadata_value = {
      jsHeapSizeLimit: memoryInfo.jsHeapSizeLimit,
      totalJSHeapSize: memoryInfo.totalJSHeapSize,
      usedJSHeapSize: memoryInfo.usedJSHeapSize,
    };

    trackPerformanceMetricEvent({
      metric_name: 'memory',
      metric_type: 'custom',
      metric_value: 0,
      metric_metadata_type: 'json',
      metric_metadata_value: JSON.stringify(metric_metadata_value),
    });
  });
});

export default memory;
